import CircularProgress from '@material-ui/core/CircularProgress';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import * as React from 'react';

export interface IProgressProps {
	open: boolean;
}

/**
 * 読み込み中表示コンポーネント
 * @param props
 */
const Progress: React.FC<IProgressProps> = props => {
	return (
		<Dialog open={props.open}>
			<DialogContent style={{ overflow: 'hidden' } /* for IE */}>
				<CircularProgress />
			</DialogContent>
		</Dialog>
	);
};

export default Progress;



// WEBPACK FOOTER //
// ./src/components/Progress.tsx